import React from 'react';

import { LinearProgress, Switch } from '@material-ui/core';

import { ErrorOutlineIcon } from 'assets/icons/alert';
import EditIcon from 'assets/icons/edit';

import { isNumeric } from '../utils';
import { Enum } from './enum';

export class AdStatus extends Enum {
    #icon;

    static items = [];

    static UNDEFINED = new AdStatus('', -1);
    static UNSPECIFIED = new AdStatus('UNSPECIFIED', 0, () => <ErrorOutlineIcon />);
    static UNKNOWN = new AdStatus('UNKNOWN', 1, () => <ErrorOutlineIcon />);
    static ENABLED = new AdStatus('ENABLED', 2, () => <Switch color='primary' checked={true} dir='rtl' />);
    static PAUSED = new AdStatus('PAUSED', 3, () => <Switch checked={false} />);
    static REMOVED = new AdStatus('REMOVED', 4, () => <ErrorOutlineIcon />);

    static FAILED = new AdStatus('FAILED', 6, () => <ErrorOutlineIcon />);
    static INPROGRESS = new AdStatus('INPROGRESS', 8, <LinearProgress color='primary' style={{ width: '35px' }} />);

    static ENQUEUED_TO_PUBLISH = new AdStatus(
        'QUEUED',
        20,
        <LinearProgress color='primary' style={{ width: '35px' }} />
    );
    static DRAFT = new AdStatus('DRAFT', 21, <EditIcon fontSize='small' />);

    constructor(name, value, icon) {
        super(name, value);

        this.#icon = icon;
        AdStatus.items.push(this);
    }

    /**
     *
     */

    equals(other) {
        return this.value === other.value && this.name === other.name;
    }

    /**
     *
     */

    get icon() {
        return this.#icon;
    }

    /**
     *
     */

    static find(criteria) {
        if (isNumeric(criteria)) {
            return AdStatus.items.find((v) => v.value === Number(criteria));
        }

        return AdStatus.items.find((v) => v.name === criteria);
    }

    /**
     *
     */

    static contains(criteria) {
        const status = AdStatus.find(criteria);

        return !!status;
    }

    /**
     *
     */

    static get(criteria) {
        return AdStatus.find(criteria) || AdStatus.UNDEFINED;
    }
}
